<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All employee log"></sm-title-bar> -->
      <sm-title-bar pageTitle="All employee log" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
  </div>
</div>


<div class="" *ngIf="!loader">
  <div class="row">
    <div class="col-md-6 col-sm-6 col-12" *ngFor="let data  of employeeLogData">
    <div class="plan-card" style="position: relative;" >
      <div class="d-flex align-items-center" style="padding-bottom: 10px;">
        <div class="" style="position: relative; flex-shrink: 0; max-width: 50px; max-height: 50px; width: 50px; height: 50px;">
          <img [src]="data.image_thumb_url ?? './assets/images/photo.png'" class="rounded-circle"
            style="max-width: 50px; height: 50px; min-width: 50px; min-height: 50px; object-fit: cover; object-position: center;"
            alt="">
          <span [style]="{backgroundColor: data.entry_type == 1 ? 'green' : 'red'}"
            style="height: 15px; width: 15px; border-radius: 50%; display: block; position: absolute; bottom: 0px; right: 0px;"></span>
        </div>
        <div class="mx-1 data_list_r">
          <h2 class="plan-title" style="color: #333;">{{data.name}}</h2>
          <p class="plan-info">
            <span class="value">{{data.employee_phone}}</span>
          </p>
        </div>
      </div>
      <div class="employee_log_se">
      <p class="plan-cost">
        <span class="label">Status: </span> <span class="value">{{ data.entry_status }} </span>,
        <span class="value">{{ data.duty_time2 }} </span>
      </p>
      <p class="plan-cost">
        <span class="label">{{data.business_name}}</span>
      </p>
      <div class="address_list elips_cls_2">
      <p>{{ data.address_line}}</p>
    </div>
    </div>
    </div>
    </div>
  </div>
</div>

<!-- <mat-card appearance="outlined" *ngIf="!loader && employeeLogData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="employeeLogData" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>

<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">timer</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>

<ng-template #image let-objValue>
  <img [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
            : './assets/images/photo.png'
        " class="img-fluid rounded-circle" />
</ng-template> -->